import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const IscMonthlyCatalogs = () => {
  return (
    <MicroFrontEnd
      name="IscCatalogs"
      src={apiConfig.microFrontEnds.IscMonthlyCatalogs}
      props={{ catalogMode: 'monthly' }}
    />
  )
}

export default IscMonthlyCatalogs
